import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login";
import store from '../store';
import axios from "axios";

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: "Login",
        component: Login
    },
    {
        path: "/configuration",
        component: () =>
            import(/* webpackChunkName: "configuration" */ "../views/Configuration.vue"),
        children: [
            {
                path: '/',
                name: "Home",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Home.vue"),
            },
            {
                path: 'clients',
                name: "Clients",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/ClientList.vue")
            },
            {
                path: 'clients/new',
                name: "NewClient",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Client.vue"),
                props: {
                    default: true,
                    isNewClient: true
                }
            },
            {
                path: 'client/:id',
                name: "Client",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Client.vue")
            },
            {path: 'clients/*', redirect: 'clients'},
            {
                path: 'portals',
                name: "ConfPortals",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/PortalList.vue")
            },
            {
                path: 'my-portals',
                name: "ConfMyPortals",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/PortalList.vue"),
                props: {
                    areMyPortal: true
                }
            },
            {
                path: 'portals/new',
                name: "ConfNewPortal",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Portal.vue"),
                props: true
            },
            {
                path: 'portal/:name',
                name: "ConfPortal",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Portal.vue")
            },
            {
                path: 'files',
                name: "ConfFiles",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Files.vue")
            },
            {
                path: 'monitoring',
                name: "Monitoring",
                component: () =>
                    import(/* webpackChunkName: "configuration" */ "../components/configuration/Monitoring.vue")
            },
            {path: 'portals/*', redirect: 'portals'},
            {
                path: "draft/:name",
                component: () =>
                    import(/* webpackChunkName: "portal" */ "../views/Portal.vue"),
                children: [
                    {
                        path: 'error',
                        name: "DraftError",
                        component: () =>
                            import(/* webpackChunkName: "portal" */ "../components/portal/errors/Error"),
                        props: true
                    },
                    {
                        path: '',
                        name: "DraftSubmission",
                        component: () =>
                            import(/* webpackChunkName: "portal" */ "../components/portal/Submission"),
                        props: true
                    },
                    {
                        path: 'confirmation',
                        name: "DraftConfirmation",
                        component: () =>
                            import(/* webpackChunkName: "portal" */ "../components/portal/Confirmation"),
                        props: true
                    },
                    {path: '*', redirect: 'error'},
                ]
            },
            {path: '*', redirect: '/configuration'},
        ]
    },
    {
        path: "/portal/error",
        component: () =>
            import(/* webpackChunkName: "portal" */ "../views/Portal.vue"),
        children: [
            {
                path: "",
                name: "Error",
                component: () =>
                    import(/* webpackChunkName: "error" */ "../components/portal/errors/Error"),
                props: true
            }
        ]
    },
    {
        path: "/portal/:name",
        component: () =>
            import(/* webpackChunkName: "portal" */ "../views/Portal.vue"),
        children: [
            {
                path: 'error',
                name: "PortalError",
                component: () =>
                    import(/* webpackChunkName: "portal" */ "../components/portal/errors/Error"),
                props: true
            },
            {
                path: '',
                name: "PortalSubmission",
                component: () =>
                    import(/* webpackChunkName: "portal" */ "../components/portal/Submission"),
                props: true
            },
            {
                path: 'confirmation',
                name: "PortalConfirmation",
                component: () =>
                    import(/* webpackChunkName: "portal" */ "../components/portal/Confirmation"),
                props: true
            },
            {path: '*', redirect: 'error'},
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/portal'];
    const authRequired = !publicPages.includes(to.path) && !to.path.startsWith('/portal');
    if (authRequired) {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user && checkExpired(user)) {
            localStorage.removeItem('user');
            user = null;
        }

        axios.get("/OppPortal/api/v1/opp/applicationSettings")
            .then(response => {
                const appSettings = response.data;

                if (!user && appSettings.trustZone) {
                    store.dispatch('auth/retrieveUser').then(
                        () => {
                            user = JSON.parse(localStorage.getItem('user'));
                            checkUser(user, next);
                        },
                        () => {
                            next('/login');
                        }
                    );
                } else {
                    checkUser(user, next);
                }

            })
            .catch(() => {
                next('/login');
            });

    } else {
        next();
    }
});

function checkUser(user, next) {
    let isExpired = checkExpired(user);

    // trying to access a restricted page + not logged in
    // redirect to login page
    if (!user || isExpired) {
        localStorage.removeItem('user');
        next('/login');
    } else {
        next();
    }
}

function checkExpired(user) {
    let isExpired = false;
    if (user && user.expirationDate) {
        const expirationDate = new Date(user.expirationDate);
        expirationDate.setTime(expirationDate.getTime() - 10 * 60 * 1000)
        const now = new Date();
        isExpired = expirationDate <= now;
    }
    return isExpired;
}

export default router;
